import { Component, OnInit } from '@angular/core';
import { Observable, Subscription, combineLatest, EMPTY, retry, switchMap, catchError, skip } from 'rxjs';
import { AllStatusCounts } from 'src/app/core/interfaces/status-counts/all-status-counts';
import { ApiService } from 'src/app/core/services/api/api.service';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { CountsService } from 'src/app/core/services/counts/counts.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { RoleService } from 'src/app/core/services/role/role.service';
import { SyncService } from 'src/app/core/services/sync/sync.service';
import { FeatureFlagService } from 'src/app/core/services/feature-flags/feature-flag.service';

@Component({
  selector: 'app-counts',
  templateUrl: './counts.component.html',
  styleUrls: ['./counts.component.scss'],
})
export class CountsComponent implements OnInit {
  currentUserRole: string;
  currentPath: string;

  allCounts: AllStatusCounts;

  countsToDisplay: string[] = [];

  syncStatusSubscription: Subscription;
  private refreshSubscription: Subscription;
  private countsSubscription: Subscription;
  private featureFlagSubscription: Subscription;

  constructor(
    private data: DataService,
    private countsService: CountsService,
    private apiService: ApiService,
    private role: RoleService,
    private auth: AuthenticationService,
    private syncService: SyncService,
    private featureFlags: FeatureFlagService
  ) {}

  // TODO: Refactor this so that it will refresh counts after all inits are done.
  ngOnInit(): void {
    this.refreshSubscription = this.countsService.refreshRequested$.subscribe(() => this.getCounts());
    this.syncStatusSubscription = this.syncService.currentSyncStatus.subscribe(
      (syncStatus) => {
        if (syncStatus.syncStatus === 'Synced Down') {
          this.getCounts();
        }
      }
    );
    this.getCounts();
    this.featureFlagSubscription = this.featureFlags.resolved$.pipe(skip(1)).subscribe(() => this.getCounts());
  }

  getCounts() {
    this.countsSubscription?.unsubscribe();
    this.countsSubscription = combineLatest([this.data.currentPath, this.auth.currentAuthStatus]).pipe(
      switchMap(([path, authStatus]) => {
        this.currentPath = path;
        this.countsToDisplay = this.countsService.buildCountsToDisplay(path);
        if (path === '/auth/login' || !authStatus) return EMPTY;
        const counts$ = this.role.getCurrentOfflineStatus()
          ? this.countsService.getOfflineCounts(this.role.getCurrentUserRole())
          : this.getAllStatusCounts();
        return counts$.pipe(catchError(error => {
          console.error(error);
          return EMPTY;
        }));
      })
    ).subscribe(counts => this.allCounts = counts);
  }

  getAllStatusCounts(): Observable<AllStatusCounts> {
    const allStatusCounts$ = this.apiService
      .getAllStatusCounts()
      .pipe(retry(3));
    return allStatusCounts$;
  }

  ngOnDestroy() {
    this.syncStatusSubscription?.unsubscribe();
    this.refreshSubscription?.unsubscribe();
    this.countsSubscription?.unsubscribe();
    this.featureFlagSubscription?.unsubscribe();
  }
}
